import '../../utils/index.mjs';
import Divider from './src/divider.mjs';
export { dividerProps } from './src/divider2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElDivider = withInstall(Divider);

export { ElDivider, ElDivider as default };
//# sourceMappingURL=index.mjs.map
